<script setup>
import {computed, watch} from 'vue';

const props = defineProps({
  shopId: Number,
  date: Date,
  submissions: {
    type: Array,
    default: () => [],
    validator: (value) => {
      return Array.isArray(value) && value.every(item => typeof item === 'string')
    }
  },
  collapseNavFn: Function,
  active: {
    type: Boolean,
    default: true
  }
})

// Checking for turned in status
const dateString = computed(() => {
  return props.active ? props.date.toISOString().split('T')[0] : '0000-00-00';
});
const eodTurnedIn = computed(() => {
  return props.active ? props.submissions.includes(dateString.value) : false;
});

// Style Properties
const buttonClass = computed(() => {
  const constantClasses = 'hover:text-primary-200'
  if (eodTurnedIn.value) {
    return `pi pi-check-circle text-emerald-600 font-bold ${constantClasses}`;
  } else {
    return `text-slate-300 pi pi-circle ${constantClasses}`;
  }
})
</script>

<template>
  <router-link v-if="active" :to="{name: 'manager-eod-report', params: {shopId: props.shopId, date: dateString}}" @click="collapseNavFn">
    <i :key="`${shopId}-${date}`" @hover="" :class="buttonClass" size="small"></i>
  </router-link>
  <i v-else :key="`${shopId}-${date}`" class="pi pi-circle-fill text-slate-200" size="small"></i>
</template>